// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-modules-Integrations-style----video-module---wrapper---3Kfjh position-relative wistia_responsive_padding","inner":"src-components-modules-Integrations-style----video-module---inner---1sF8P height-100 pinTL position-absolute width-100 wistia_responsive_wrapper","video":"src-components-modules-Integrations-style----video-module---video---1cGzo popover=true popoverAnimateThumbnail=true display-inlineBlock position-relative videoFoam=true wistia_embed height-100 width-100"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Integrations/style/video.module.css
// module id = 1483
// module chunks = 168707334958949